import { render, staticRenderFns } from "./share_settings.vue?vue&type=template&id=0721b2f0&scoped=true&"
import script from "./share_settings.vue?vue&type=script&lang=js&"
export * from "./share_settings.vue?vue&type=script&lang=js&"
import style0 from "./share_settings.vue?vue&type=style&index=0&id=0721b2f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0721b2f0",
  null
  
)

export default component.exports